export const ApckPlaceholder = {
    props: {
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        icon: {
            type: String,
            default: '',
        },
    },
    template: `<div class="placeholder">
      <div class="placeholder__message">
        <div v-if="icon" class="placeholder__icon"><i :class="['fa', icon]"></i></div>

        <div class="placeholder__title">{{ title }}</div>

        <p class="placeholder__description">{{ description }}</p>
        <div class="placeholder__slot">
          <slot></slot>
        </div>
      </div>
    </div>`,
};
